export const onCheckAdmin = ({ user }) => {
  return user?.attributes?.profile?.protectedData?.isAdmin || false;
};
